<div class="card shadow border-0 mb-3">
  <div class="card-header fw-bold bg-tertiary p-3 border-0">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-link-45deg me-2 text-primary"></i>Tracking & Postback</h2>
  </div>

  <div class="card-body">
    <ul class="nav nav-tabs mb-3" id="postbackTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <a [routerLink]="'postback'" routerLinkActive="active" class="nav-link">S2S Postback</a>
      </li>
      <li class="nav-item not-implemented" role="presentation">
        <button class="nav-link">Pixel / Iframe</button>
      </li>
      <li class="nav-item not-implemented" role="presentation">
        <button class="nav-link">Facebook pixel</button>
      </li>
    </ul>

    <router-outlet></router-outlet>
  </div>
</div>
